import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, MenuItem, Box, Grid } from "@mui/material";
import { headers } from "../utils/utils";


const SearchableSelect = ({
  label,
  icon: Icon,
  grid,
  placeHolder,
  value,
  onChange,
  groupName,
  name,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_SYS_CONFIG_MGMT +
          "/systemConfig/config?name=" +
          groupName +
          "&active=true",
        {
          method: "GET",
          headers: headers(),
        },
      );

      const data = await response.json();
      const transformedData = data.map((item) => ({
        value: item.id, // Assign `id` to `value`
        label: item.value ? item.value : "D", // Assign `value` to `label`
      }));

      setOptions(transformedData);
    } catch (error) {}
  };

  const handleAddNew = async (newValue) => {
    if (newValue) {
      const newData = {
        value: newValue,
        groupName: groupName, // Fixed group name for the tag
      };

      try {
        // Save the tag in the backend
        const response = await fetch(
          process.env.REACT_APP_SYS_CONFIG_MGMT + "/systemConfig/save",
          {
            method: "POST",
            headers: headers(),
            body: JSON.stringify(newData),
          },
        );
        const data = await response.json();
        if (response.ok) {
          const newOption = { label: newValue, value: data.id };
          setOptions((prevOptions) => [...prevOptions, newOption]);
          setSelectedOption(newOption);
        } else {
        }
      } catch (error) {}
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
  };

  const handleSelectionChange = (event, newValue) => {
    const syntheticEvent = {
      target: {
        name: name, // Pass the groupName or any identifier as the name
        value: newValue?.value || "", // Set the value to the selected option's value or an empty string
      },
    };

    if (newValue?.value === "new") {
      // Call your function when "Add new" is selected
      handleAddNew(inputValue);
    } else {
      // Update the selected option
      setSelectedOption(newValue);
    }

    // Trigger onChange from the parent with the synthetic event
    onChange(syntheticEvent);
  };

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(inputValue.toLowerCase()),
  );

  // Check if the current input value is already an option
  const isOptionAvailable = options.some(
    (option) => option.label.toLowerCase() === inputValue.toLowerCase(),
  );

  return (
    <Grid item xs={grid ? Number(grid) : 12}>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          fontSize: "14px", // Adjust as needed
        }}
      >
        <Icon />
        {label}
      </Box>

      <Autocomplete
        value={selectedOption}
        onChange={handleSelectionChange} // Update the selection handler
        inputValue={inputValue}
        onInputChange={handleInputChange} // Handle input value change
        options={[
          ...filteredOptions,
          { label: "Add new: " + inputValue, value: "new" },
        ]}
        getOptionLabel={(option) => option.label}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" placeholder={placeHolder} />
        )}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderOption={(props, option) => (
          <MenuItem {...props} key={option.value}>
            {option.value === "new" ? (
              <span>{option.label}</span>
            ) : (
              option.label
            )}
          </MenuItem>
        )}
      />
    </Grid>
  );
};

export default SearchableSelect;
